export default () => {

  let btns = document.querySelectorAll('.item__share')
  btns ? btns.forEach(btn => {
    btn.addEventListener('click', (e) => {
      let copytext = document.createElement('input')
      copytext.value = window.location.href
      document.body.appendChild(copytext)
      copytext.select()
      document.execCommand('copy')
      document.body.removeChild(copytext)
      let text = btn.innerHTML;
      btn.innerText = 'Скопировано'
      btn.style.padding = '12px 19px'
      btn.disabled = true
      setTimeout(() => {
        btn.innerHTML = text
        btn.style.padding = '5px 12px'
        btn.disabled = false
      }, 3000)
    })
  }) : null
}
